import React from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { Toaster } from 'react-hot-toast';
import { AuthProvider, useAuth } from './contexts/AuthContext';
import Sidebar from './components/Sidebar';
import LoginPage from './pages/LoginPage';
import DashboardPage from './pages/DashboardPage';
import EventosPage from './pages/EventosPage';
import EventoDetallePage from './pages/EventoDetallePage';
import ConsultasPage from './pages/ConsultasPage';
import VehiculosPage from './pages/VehiculosPage';
import ClientesPage from './pages/ClientesPage';
import CatalogosPage from './pages/CatalogosPage';
import UsuariosPage from './pages/UsuariosPage';
import ConfiguracionPage from './pages/ConfiguracionPage';
import WebhookProveedoresPage from './pages/WebhookProveedoresPage';

function ProtectedRoute({ children, adminOnly }) {
  const { user } = useAuth();
  if (!user) return <Navigate to="/login" replace />;
  if (adminOnly && user.rol !== 'admin') return <Navigate to="/dashboard" replace />;
  return children;
}

function AppLayout({ children }) {
  return (
    <div className="app-shell">
      <Sidebar />
      <main className="main-content">
        <div className="page-body">{children}</div>
      </main>
    </div>
  );
}

function AppRoutes() {
  const { user } = useAuth();
  return (
    <Routes>
      <Route path="/login" element={user ? <Navigate to="/dashboard" replace /> : <LoginPage />} />
      <Route path="/dashboard" element={<ProtectedRoute><AppLayout><DashboardPage /></AppLayout></ProtectedRoute>} />
      <Route path="/eventos" element={<ProtectedRoute><AppLayout><EventosPage /></AppLayout></ProtectedRoute>} />
      <Route path="/eventos/:id" element={<ProtectedRoute><AppLayout><EventoDetallePage /></AppLayout></ProtectedRoute>} />
      <Route path="/consultas" element={<ProtectedRoute><AppLayout><ConsultasPage /></AppLayout></ProtectedRoute>} />
      <Route path="/vehiculos" element={<ProtectedRoute><AppLayout><VehiculosPage /></AppLayout></ProtectedRoute>} />
      <Route path="/clientes" element={<ProtectedRoute><AppLayout><ClientesPage /></AppLayout></ProtectedRoute>} />
      <Route path="/catalogos" element={<ProtectedRoute><AppLayout><CatalogosPage /></AppLayout></ProtectedRoute>} />
      <Route path="/webhook-proveedores" element={<ProtectedRoute adminOnly><AppLayout><WebhookProveedoresPage /></AppLayout></ProtectedRoute>} />
      <Route path="/usuarios" element={<ProtectedRoute adminOnly><AppLayout><UsuariosPage /></AppLayout></ProtectedRoute>} />
      <Route path="/configuracion" element={<ProtectedRoute adminOnly><AppLayout><ConfiguracionPage /></AppLayout></ProtectedRoute>} />
      <Route path="*" element={<Navigate to={user ? "/dashboard" : "/login"} replace />} />
    </Routes>
  );
}

export default function App() {
  return (
    <BrowserRouter>
      <AuthProvider>
        <AppRoutes />
        <Toaster position="top-right" toastOptions={{
          style: { background:'var(--bg-elevated)', color:'var(--text-primary)', border:'1px solid var(--border-light)', fontFamily:'var(--font-body)', fontSize:13 },
          success: { iconTheme: { primary:'var(--success)', secondary:'#000' } },
          error: { iconTheme: { primary:'var(--danger)', secondary:'#fff' } },
        }}/>
      </AuthProvider>
    </BrowserRouter>
  );
}
